export const sentryIgnoreMessages: string[] = ['TypeError', 'Load failed'];

export const sentryIgnoreExceptionValues: string[] = [
    'There was an error while hydrating.',
    'Hydration failed because the initial UI does not match what was rendered on the server.',
    'did not match',
    'WebSocket connection',
    'TypeError',
    'Load failed',
    "can't access dead object",
    "null is not an object (evaluating '(n=n.stateNode).parentNode.removeChild')",
    "Cannot read properties of null (reading 'removeChild')",
    'ChunkLoadError: Loading chunk 524 failed',
    "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.",
    'The object can not be found here',
    'The operation was aborted.',
    'Invalid call to runtime.sendMessage(). Tab not found.',
];

export const sentryIgnoreExceptionTypes: string[] = [
    'UnhandledRejection',
    'TypeError',
    'Load failed',
    'AbortError',
];
